import { type HardwareMicDevice } from '@/tauri/dictation/api';
import { atom } from 'jotai';

/** Raw hardware-mic snapshot mirrored from the Rust HID reader. */
export const hardwareMicDevicesAtom = atom<HardwareMicDevice[]>([]);

export const hardwareMicDeviceKey = (d: HardwareMicDevice) =>
  `${d.model}:${d.vid}:${d.pid}:${d.serial ?? ''}`;
